module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "fresh-datatables"
  }, [_c('table', {
    staticClass: "table table-striped table-no-bordered table-hover",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "datatables",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [_vm._l((_vm.documents), function(doc, idx) {
    return [_c('tr', {
      key: doc.id || idx
    }, [_c('td', [_c('a', {
      attrs: {
        "href": "javascript:void(0);"
      },
      on: {
        "click": function($event) {
          return _vm.downloadFile(doc, idx)
        }
      }
    }, [_vm._v(_vm._s(doc.fileName))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(doc.uploadedBy))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(doc.uploadedDate))]), _vm._v(" "), _c('td', [_c('a', {
      staticClass: "btn btn-link btn-danger",
      on: {
        "click": function($event) {
          return _vm.confirmDeleteDocument(doc.id, idx)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-fw fa-trash"
    })])])])]
  })], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "dropbox"
  }, [_c('input', {
    staticClass: "input-file",
    attrs: {
      "type": "file",
      "name": "uploadInput",
      "disabled": _vm.isUploading,
      "accept": "*/*"
    },
    on: {
      "change": function($event) {
        return _vm.filesChange($event.target.name, $event.target.files);
      }
    }
  }), _vm._v(" "), (!_vm.currentUploadFile) ? _c('p', [_c('i', {
    staticClass: "fa fa-upload"
  }), _c('br'), _vm._v("\n                  Drag your file here or click to browse...\n                ")]) : _vm._e(), _vm._v(" "), (_vm.isUploading) ? _c('p', [_vm._v("\n                  Uploading file..\n                ")]) : _vm._e(), _vm._v(" "), (_vm.currentUploadFile) ? _c('p', [_c('i', {
    staticClass: "fa fa-upload"
  }), _c('br'), _vm._v("\n                  " + _vm._s(_vm.currentUploadFile.name) + "\n                ")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('button', {
    staticClass: "btn btn-icon btn-wd btn-success",
    attrs: {
      "disabled": !_vm.currentUploadFile
    },
    on: {
      "click": function($event) {
        return _vm.uploadToServer()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-upload"
  }), _vm._v(" Upload")]), _vm._v(" "), (_vm.showGenerate) ? _c('button', {
    staticClass: "btn btn-icon btn-wd btn-success",
    on: {
      "click": function($event) {
        return _vm.showGenerateModal()
      }
    }
  }, [_vm._v(" Generate Report")]) : _vm._e()])])])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "generateModal",
      "height": "auto"
    }
  }, [_c('div', {
    staticClass: "col-sm-12",
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('div', {
    staticClass: "form-group",
    staticStyle: {
      "padding-top": "12px"
    }
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Generate Report")])]), _vm._v(" "), _c('div', {
    staticClass: "card-body form"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "generateType"
    }
  }, [_vm._v("Select a report to generate and download")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.generateType),
      expression: "generateType"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.generateType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "id": "pickupOrder",
      "selected": ""
    }
  }, [_vm._v("Pick-up Order")]), _vm._v(" "), _c('option', {
    attrs: {
      "id": "proForma"
    }
  }, [_vm._v("Pro Forma")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group form-actions float-right",
    staticStyle: {
      "margin-bottom": "16px"
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.hideGenerateModal()
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success btn-wd",
    on: {
      "click": function($event) {
        return _vm.generateDocument()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" Generate")])])])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Documents")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Uploaded By")]), _vm._v(" "), _c('th', [_vm._v("Uploaded Date")]), _vm._v(" "), _c('th', {
    staticClass: "disabled-sorting"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21591525"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UploadDocument.vue
// module id = 685
// module chunks = 0